const config = {
  development: {
    api: 'http://localhost:3002',
    socket: 'http://dev.kambria.io:8080',
  },

  /**
   * !!!WARNING!!!
   * DO NOT CHANGE THE CONFIGURATIONS BELOW. THEY ARE USED BY CI/CD
   */
  staging: {
    api: 'https://staging-ced-api.kambria.io',
    socket: 'https://staging-cedsocket.kambria.io',
  },
  uat: {
    api: 'https://uat-ced-api.kambria.io',
    socket: 'https://uat-ced-socket.kambria.io',
  },
  production: {
    api: 'https://ced-api.kambria.io',
    socket: 'https://ced-socket.kambria.io',
  },
};

export default config;
